module.exports = __webpack_public_path__ + "static/media/akridge_logo_color_rgb.0959f737.svg";